"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementStatus = void 0;
var StatementStatus;
(function (StatementStatus) {
    StatementStatus["Draft"] = "draft";
    StatementStatus["Issued"] = "issued";
    StatementStatus["Paid"] = "paid";
    StatementStatus["Overdue"] = "overdue";
    StatementStatus["Pending"] = "pending";
    StatementStatus["Cancelled"] = "cancelled";
})(StatementStatus = exports.StatementStatus || (exports.StatementStatus = {}));
